// This helper function sends a custom event to Google Analytics.
// It's designed to be called from client-side components.

interface GTagEvent {
  action: string;
  params: {
    [key: string]: string | number | undefined | string[];
  };
}

declare global {
  interface Window {
    gtag?: (command: 'event', action: string, params: GTagEvent['params']) => void;
  }
}

// Check if the window object and gtag function exist before calling.
export const trackEvent = ({ action, params }: GTagEvent) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
};
